module.exports = __webpack_public_path__ + "assets/views/popups/isi_logo_outro_ru.png";